import React from 'react';
import styles from './aiSearchModal.module.scss';
import AISearchForm from './AISearchForm';
import { AISearchFormFields } from './AISearchSchema';
import FormModal from 'v2/common/FormModal/FormModal';
import classnames from 'classnames';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import restFactory from 'v2/utils/restFactory';
import { toast } from 'react-toastify';
import { FileType } from 'v2/models';

interface CreateAISearchModalProps {
  onClose?: (hasNewSearchCreated?: boolean) => void;
}

const CreateAISearchModal = ({ onClose }: CreateAISearchModalProps) => {
  const formContext = useForm<AISearchFormFields>({
    mode: 'onChange',
    defaultValues: {
      companyList: {
        is_all: false,
        list: [],
      },
      fileList: {
        is_all: true,
        list: [],
      },
      searchType: '',
      fileTypes: [FileType.legal_document],
    },
  });

  const { mutate: createSearch, isLoading: isCreateSearchLoading } =
    useMutation(
      async (data: AISearchFormFields) => {
        const dataCleaned = {
          all_companies: data.companyList.is_all,
          data_vendors: data.companyList.list.map((company) => company.id),
          all_files: data.fileList.is_all,
          files: data.fileList.list.map((file) => file.id),
          search_type: data.searchType,
          file_types: data.fileTypes,
          custom_chat: data.customChat,
        };
        return await restFactory.post(
          `/dj/api/v1/ai_conversation/`,
          dataCleaned
        );
      },
      {
        onSuccess: () => {
          onClose?.(true);
          toast.success('Search saved.');
        },
        onError: () => {
          toast.error('Error saving search.');
        },
      }
    );

  const handleOnSubmit = (data: AISearchFormFields) => {
    createSearch(data);
  };

  return (
    <FormModal
      title="Create a New Search"
      shouldResetForm={false}
      onCancel={() => onClose?.()}
      formContext={formContext}
      className={classnames(styles.viewModals)}
      onSubmit={handleOnSubmit}
      isLoading={isCreateSearchLoading}
    >
      <AISearchForm />
    </FormModal>
  );
};

export default CreateAISearchModal;
